var buildpc = "https://shopfront-cdn.tekoapis.com/static/4c02f4e5830e527a.svg";

export { buildpc as default };
